// extracted by mini-css-extract-plugin
export default {"noCoin":"PodPersona_noCoin__8Fciv"};